import "./styles-global/reset.css";
import "./styles-global/global.css";
import Routing from "./routing/Routing";

function App() {
  return (
    <>
      <Routing />
    </>
  );
}

export default App;
